/**
 * @generated SignedSource<<3b03f5bc0e6110e1325af0401c017c02>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ReleaseTypeEnum = "album" | "compilation" | "single";
export type ReleaseTypename = "ReleaseNode" | "UnreleasedReleaseNode";
export type UpdateOrCreateFeaturedDealMutationInput = {
  allReleases?: ReadonlyArray<UpdateOrCreateReleaseMutationInput | null> | null;
  artistNodeId: string;
  creativeAmountRaising?: number | null;
  distributionAgreement?: string | null;
  distributor?: string | null;
  featuredDealId?: string | null;
  inPocketAmountRaising?: number | null;
  managerCompany?: string | null;
  managerEmail?: string | null;
  managerLink?: string | null;
  managerName?: string | null;
  marketingAmountRaising?: number | null;
  partnerSplitPostRecoupment?: number | null;
  partnerSplitPreRecoupment?: number | null;
  producerAgreement?: string | null;
  soundLink?: string | null;
  soundRecordingIds?: ReadonlyArray<string | null> | null;
  termLengthMonths?: number | null;
  tiktokSoundIds?: ReadonlyArray<string | null> | null;
  whyInvestNow?: string | null;
};
export type UpdateOrCreateReleaseMutationInput = {
  id?: string | null;
  isVisible?: boolean | null;
  name?: string | null;
  releaseType?: ReleaseTypeEnum | null;
  soundLink?: string | null;
  tracksCount?: number | null;
  typename: ReleaseTypename;
};
export type mutationsCreateFeaturedDealMutation$variables = {
  data: UpdateOrCreateFeaturedDealMutationInput;
};
export type mutationsCreateFeaturedDealMutation$data = {
  readonly updateOrCreateFeaturedDeal: {
    readonly featuredDeal: {
      readonly artist: {
        readonly featuredDeals: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly " $fragmentSpreads": FragmentRefs<"ArtistManageDeals_featuredDeals">;
            } | null;
          } | null>;
        };
        readonly " $fragmentSpreads": FragmentRefs<"ArtistManageDeals_artist" | "ArtistManageReleases_artist" | "ArtistManagerInfo_artist">;
      };
    } | null;
  } | null;
};
export type mutationsCreateFeaturedDealMutation = {
  response: mutationsCreateFeaturedDealMutation$data;
  variables: mutationsCreateFeaturedDealMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "data"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "data",
    "variableName": "data"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "soundLink",
  "storageKey": null
},
v4 = [
  (v2/*: any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v6 = [
  (v2/*: any*/),
  (v5/*: any*/)
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thumbnailUrl",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "releaseType",
  "storageKey": null
},
v10 = [
  (v7/*: any*/),
  (v8/*: any*/),
  (v9/*: any*/)
],
v11 = {
  "kind": "Literal",
  "name": "first",
  "value": 1000
},
v12 = [
  (v2/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v5/*: any*/),
      (v9/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "releaseDate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updatedAt",
        "storageKey": null
      },
      (v7/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isVisible",
        "storageKey": null
      },
      (v8/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tracksCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "canDelete",
        "storageKey": null
      },
      (v3/*: any*/)
    ],
    "type": "ReleaseInterface",
    "abstractKey": "__isReleaseInterface"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "mutationsCreateFeaturedDealMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateOrCreateFeaturedDealMutation",
        "kind": "LinkedField",
        "name": "updateOrCreateFeaturedDeal",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FeaturedDealNode",
            "kind": "LinkedField",
            "name": "featuredDeal",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ArtistNode",
                "kind": "LinkedField",
                "name": "artist",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ArtistManagerInfo_artist"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ArtistManageDeals_artist"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FeaturedDealNodeConnection",
                    "kind": "LinkedField",
                    "name": "featuredDeals",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FeaturedDealNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FeaturedDealNode",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "ArtistManageDeals_featuredDeals"
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ArtistManageReleases_artist"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "mutationsCreateFeaturedDealMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateOrCreateFeaturedDealMutation",
        "kind": "LinkedField",
        "name": "updateOrCreateFeaturedDeal",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FeaturedDealNode",
            "kind": "LinkedField",
            "name": "featuredDeal",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ArtistNode",
                "kind": "LinkedField",
                "name": "artist",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "managerName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "managerLink",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "managerCompany",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "managerEmail",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FeaturedDealNodeConnection",
                    "kind": "LinkedField",
                    "name": "featuredDeals",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FeaturedDealNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FeaturedDealNode",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "inPocketAmountRaising",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "marketingAmountRaising",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "creativeAmountRaising",
                                "storageKey": null
                              },
                              (v3/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TikTokSoundNodeConnection",
                                "kind": "LinkedField",
                                "name": "tiktokSounds",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TikTokSoundNodeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "TikTokSoundNode",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": (v4/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "whyInvestNow",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "partnerSplitPreRecoupment",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "partnerSplitPostRecoupment",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "termLengthMonths",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SoundRecordingNodeConnection",
                                "kind": "LinkedField",
                                "name": "soundRecordings",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "SoundRecordingNodeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SoundRecordingNode",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": (v4/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ReleaseNodeConnection",
                                "kind": "LinkedField",
                                "name": "releases",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ReleaseNodeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ReleaseNode",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": (v6/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "UnreleasedReleaseNodeConnection",
                                "kind": "LinkedField",
                                "name": "unreleasedReleases",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "UnreleasedReleaseNodeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "UnreleasedReleaseNode",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": (v6/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "status",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "totalAmountRaising",
                                "storageKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ReleaseNodeConnection",
                                    "kind": "LinkedField",
                                    "name": "releases",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ReleaseNodeEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ReleaseNode",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": (v10/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "UnreleasedReleaseNodeConnection",
                                    "kind": "LinkedField",
                                    "name": "unreleasedReleases",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "UnreleasedReleaseNodeEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "UnreleasedReleaseNode",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": (v10/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "OfferFeaturedDealInterface",
                                "abstractKey": "__isOfferFeaturedDealInterface"
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": [
                      (v11/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "orderBy",
                        "value": "-releaseDate"
                      }
                    ],
                    "concreteType": "ReleaseNodeConnection",
                    "kind": "LinkedField",
                    "name": "releasesPrefetch",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ReleaseNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ReleaseNode",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": (v12/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "releasesPrefetch(first:1000,orderBy:\"-releaseDate\")"
                  },
                  {
                    "alias": null,
                    "args": [
                      (v11/*: any*/),
                      {
                        "kind": "Literal",
                        "name": "orderBy",
                        "value": "-createdAt"
                      }
                    ],
                    "concreteType": "UnreleasedReleaseNodeConnection",
                    "kind": "LinkedField",
                    "name": "unreleasedReleasesPrefetch",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UnreleasedReleaseNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "UnreleasedReleaseNode",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": (v12/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "unreleasedReleasesPrefetch(first:1000,orderBy:\"-createdAt\")"
                  }
                ],
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6fb523feb5a2e4b5f6ddf7329849f364",
    "id": null,
    "metadata": {},
    "name": "mutationsCreateFeaturedDealMutation",
    "operationKind": "mutation",
    "text": "mutation mutationsCreateFeaturedDealMutation(\n  $data: UpdateOrCreateFeaturedDealMutationInput!\n) {\n  updateOrCreateFeaturedDeal(data: $data) {\n    featuredDeal {\n      artist {\n        ...ArtistManagerInfo_artist\n        ...ArtistManageDeals_artist\n        featuredDeals {\n          edges {\n            node {\n              ...ArtistManageDeals_featuredDeals\n              id\n            }\n          }\n        }\n        ...ArtistManageReleases_artist\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment ArtistManageDeals_artist on ArtistNode {\n  managerName\n  managerLink\n  managerCompany\n  managerEmail\n  ...DealMerchandisingFormPage_artist\n}\n\nfragment ArtistManageDeals_featuredDeals on FeaturedDealNode {\n  id\n  inPocketAmountRaising\n  marketingAmountRaising\n  creativeAmountRaising\n  soundLink\n  tiktokSounds {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n  whyInvestNow\n  partnerSplitPreRecoupment\n  partnerSplitPostRecoupment\n  termLengthMonths\n  soundRecordings {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n  releases {\n    edges {\n      node {\n        id\n        __typename\n      }\n    }\n  }\n  unreleasedReleases {\n    edges {\n      node {\n        id\n        __typename\n      }\n    }\n  }\n  ...DealManageable_featuredDeal\n}\n\nfragment ArtistManageReleases_artist on ArtistNode {\n  id\n  releasesPrefetch(orderBy: \"-releaseDate\", first: 1000) {\n    edges {\n      node {\n        ...ArtistManageReleases_releasesSection\n        id\n      }\n    }\n  }\n  unreleasedReleasesPrefetch(orderBy: \"-createdAt\", first: 1000) {\n    edges {\n      node {\n        ...ArtistManageReleases_releasesSection\n        id\n      }\n    }\n  }\n}\n\nfragment ArtistManageReleases_releasesSection on ReleaseInterface {\n  __isReleaseInterface: __typename\n  __typename\n  id\n  releaseType\n  releaseDate\n  updatedAt\n  ...ReleaseListItem_release\n}\n\nfragment ArtistManagerInfo_artist on ArtistNode {\n  id\n  managerName\n  managerLink\n  managerCompany\n  managerEmail\n}\n\nfragment DealManageMenu_featuredDeal on FeaturedDealNode {\n  id\n  status\n}\n\nfragment DealManageable_featuredDeal on FeaturedDealNode {\n  id\n  status\n  totalAmountRaising\n  ...ReleaseIconsNames_query\n  ...DealManageMenu_featuredDeal\n}\n\nfragment DealMerchandisingFormPage_artist on ArtistNode {\n  id\n}\n\nfragment ReleaseDetails_release on ReleaseInterface {\n  __isReleaseInterface: __typename\n  isVisible\n  name\n  ...useReleaseMetadata_release\n}\n\nfragment ReleaseIconsNames_query on OfferFeaturedDealInterface {\n  __isOfferFeaturedDealInterface: __typename\n  ...ReleaseIconsNames_releaseImages\n  ...useFeaturedDealTitle\n}\n\nfragment ReleaseIconsNames_releaseImages on OfferFeaturedDealInterface {\n  __isOfferFeaturedDealInterface: __typename\n  releases {\n    edges {\n      node {\n        thumbnailUrl\n        id\n      }\n    }\n  }\n  unreleasedReleases {\n    edges {\n      node {\n        thumbnailUrl\n        id\n      }\n    }\n  }\n}\n\nfragment ReleaseListItem_release on ReleaseInterface {\n  __isReleaseInterface: __typename\n  thumbnailUrl\n  isVisible\n  ...ReleaseDetails_release\n  ...ReleaseStatusMenu_release\n}\n\nfragment ReleaseStatusMenu_release on ReleaseInterface {\n  __isReleaseInterface: __typename\n  __typename\n  id\n  isVisible\n  canDelete\n  ...UpdateOrCreateReleaseModal_release\n}\n\nfragment UpdateOrCreateReleaseModal_release on ReleaseInterface {\n  __isReleaseInterface: __typename\n  __typename\n  id\n  name\n  releaseType\n  soundLink\n  isVisible\n  tracksCount\n}\n\nfragment useFeaturedDealTitle on OfferFeaturedDealInterface {\n  __isOfferFeaturedDealInterface: __typename\n  releases {\n    edges {\n      node {\n        name\n        releaseType\n        id\n      }\n    }\n  }\n  unreleasedReleases {\n    edges {\n      node {\n        name\n        releaseType\n        id\n      }\n    }\n  }\n}\n\nfragment useReleaseMetadata_release on ReleaseInterface {\n  __isReleaseInterface: __typename\n  releaseType\n  tracksCount\n  releaseDate\n}\n"
  }
};
})();

(node as any).hash = "aa89928d986a6904bb42dbe45a4b3438";

export default node;
